import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { InfoIcon, ReportProblemIcon } from '../../../../icons';
import { useDispatch } from 'react-redux';
import { notificationSelectedAction, notificationSelectedDeviceAction } from '../../../../views/Notifications/actions';

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  arrowForwardIcon: {
    color: theme.palette.icon,
  },
}));

const NotificationList = props => {
  const { notifications, className, path, ...rest } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const classes = useStyles();

  const handleListItemClick = (notification) => {
    dispatch(notificationSelectedDeviceAction.Completed(notification.deviceIMEI));
    dispatch(notificationSelectedAction.Completed(notification.uuid));
    props.onClose();
    history.push(path);
  };

  const avatars = {
    ALARM: <ReportProblemIcon color="error" />,
    NOTIFICATION: <InfoIcon color="primary" />,
  };

  const safeNotifications = Array.isArray(notifications) ? [...notifications].slice(0, 8) : [];

  return (
    <List {...rest} className={clsx(classes.root, className)} disablePadding>
      {safeNotifications.map((notification, i) => {
        const createdAt = moment(notification.createdAt);
        return (
          <ListItem
            key={notification.id}
            className={classes.listItem}
            divider={i < safeNotifications.length - 1}
            onClick={() => handleListItemClick(notification)}>
            <ListItemAvatar>{avatars[notification.type]}</ListItemAvatar>
            <ListItemText
              primary={notification.message}
              primaryTypographyProps={{ variant: 'body1' }}
              secondary={`${notification.deviceName} | ${createdAt.format('hh:mm A, DD MMM')}`}
            />
            <ArrowForwardIcon className={classes.arrowForwardIcon} />
          </ListItem>
        );
      })}
    </List>
  );
};

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  path: PropTypes.string,
  onClose: PropTypes.func
};

export default NotificationList;
